import { FC, memo } from 'react';

import { useForm } from 'react-hook-form';

import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { usePasswordRecovery } from '~/modules/auth/hooks/usePasswordRecovery';

import { FormGroup } from '~/shared/components/Form/FormGroup';
import { ControlledInput } from '~/shared/components/Form/ControlledInput';

import { IPasswordRecoveryFormData } from '~/modules/auth/interfaces/IPasswordRecoveryFormData';

import { StepWrapper } from '../StepWrapper';

const formSchemaValidation = Yup.object().shape({
  newPassword: Yup.string().required('Nova senha é obrigatório'),
  newPasswordConfirmation: Yup.string()
    .required('Confirmação da nova senha é obrigatório')
    .oneOf(
      [Yup.ref('newPassword'), null],
      'A confirmação da nova senha não confere'
    ),
});

const BaseStepFour: FC = () => {
  const { resetPassword } = usePasswordRecovery();

  const {
    control,
    formState: { errors, isSubmitting },
    handleSubmit,
  } = useForm<
    Pick<IPasswordRecoveryFormData, 'newPassword' | 'newPasswordConfirmation'>
  >({
    resolver: yupResolver(formSchemaValidation),
    defaultValues: { newPassword: '', newPasswordConfirmation: '' },
  });

  return (
    <StepWrapper
      step={4}
      onSubmit={handleSubmit(resetPassword)}
      isSubmitting={isSubmitting}
    >
      <FormGroup>
        <ControlledInput
          control={control}
          name="newPassword"
          placeholder="Digite sua nova senha"
          type="password"
          error={errors.newPassword}
          autoComplete="new-password"
          size="lg"
        />
      </FormGroup>

      <FormGroup>
        <ControlledInput
          control={control}
          name="newPasswordConfirmation"
          error={errors.newPasswordConfirmation}
          type="password"
          placeholder="Digite sua nova senha novamente"
          autoComplete="new-password"
          size="lg"
        />
      </FormGroup>
    </StepWrapper>
  );
};

export const StepFour = memo(BaseStepFour);
